import { render } from "./EditItemSort.vue?vue&type=template&id=c1a60ae0&scoped=true"
import script from "./EditItemSort.vue?vue&type=script&lang=js"
export * from "./EditItemSort.vue?vue&type=script&lang=js"

import "./EditItemSort.vue?vue&type=style&index=0&id=c1a60ae0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a60ae0"]])

export default __exports__